export default __webpack_public_path__ + "static/media/patrick-tomasso-Oaqk7qqNh_c-unsplash.61c03b03.jpg";